<app-icon *ngIf="icon"
          class="icon"
          [library]="library"
          [variant]="icon">
</app-icon>
<span class="text">
  <ng-content></ng-content>
</span>
